import { render, staticRenderFns } from "./StudentWork.vue?vue&type=template&id=19db6c36&scoped=true"
import script from "./StudentWork.vue?vue&type=script&lang=js"
export * from "./StudentWork.vue?vue&type=script&lang=js"
import style0 from "./StudentWork.vue?vue&type=style&index=0&id=19db6c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db6c36",
  null
  
)

export default component.exports